import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, DEFAULTNFTIMAGE } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData, getCollectionDetailsFromLibrary, priceValidation, getBlockChainContract, isUserSessionActive, handleLogout } from '../helpers/Library';
import Loader from '../commons/Loader';
import axios from "axios";
import { ethers } from "ethers";
import web3 from "web3";
import { Seaport } from "@opensea/seaport-js";
import { Chain, OpenSeaSDK } from "opensea-js";
import BigNumber from "bignumber.js";





const CreateNft = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [showTraitPopup, setShowTraitPopup] = useState(false);
    const [traitList, setTraitList] = useState([]);
    const [nftCollections, setNftCollections] = useState([]);
    const [nftImage, setNftImage] = useState(DEFAULTNFTIMAGE);
    const [nftImageForPayload, setNftImageForPayload] = useState(null);

    const [showEditTraitPopup, setEditTraitPopup] = useState(false);
    const [showInsufficientBalancePopup, setInsufficientBalancePopup] = useState(false);
    const [showPrivateKeyMetaMaskPopup, setPrivateKeyMetaMaskPopup] = useState(false);
    const [metaMaskPrivateKey, setMetaMaskPrivateKey] = useState('');

    const [editTraitName, setEditTraitName] = useState('');
    const [editTraitValue, setEditTraitValue] = useState('');
    const [editTraitList, setEditTraitList] = useState([]);
    const [userBalance, setUserBalance] = useState(0);
    const [transactionFees, setTransactionFees] = useState(0);
    const [currencyCode, setCurrencyCode] = useState('');

    const [btnMintNft, setBtnMintNft] = useState(false);
    const [showSuccessMintNftModal, setShowSuccessMintNftModal] = useState(false);
    const [lastInsetedId, setLastInsertedId] = useState('')
    const [collectionContractAddress, setCollectionContractAddress] = useState('')
    const [entityData, setEntityData] = useState('')
    const [contractAddress, setContractAddress] = useState('')
    const [abi, setAbi] = useState('')
    /* Method defination for adding trait */
    let handleAddTraits = () => {
        let traits = traitList;
        let traitName = document.getElementById('traitName').value;
        let traitValue = document.getElementById('traitValue').value;
        //let traitFloorPrice = document.getElementById('traitFloorPrice').value;
        //let traitFloorPriceNetwork = document.getElementById('traitFloorPriceNetwork').value;
        if (traitName != '' && traitValue != '') {
            let obj = {
                traitName: traitName,
                traitValue: traitValue,
                // traitFloorPrice: traitFloorPrice,
                // traitFloorPriceNetwork: traitFloorPriceNetwork,
            }
            traits.push(obj)
            setTraitList(traits);
            setShowTraitPopup(false);
            document.getElementById('traitName').value = '';
            document.getElementById('traitValue').value = '';
            //document.getElementById('traitFloorPrice').value = '';
            //document.getElementById('traitFloorPriceNetwork').value = '';
        } else {
            showToast('error', 'Please provide all the traits details');
        }
    }



    /* method definition for edit trait */

    const handleEditTraits = () => {
        let traits = traitList;
        console.log('TRAITS', traits)
        traits.shift();
        if (editTraitName != '' && editTraitValue) {
            let obj = {
                traitName: editTraitName,
                traitValue: editTraitValue
            }
            traits.push(obj);
            setTraitList(traits);
            setEditTraitPopup(false)
        } else {
            showToast('error', 'Please provide all the traits details');

        }
    }

    /* Method defination for deleting trait */
    let handleDeleteTraits = (traitName) => {
        let traits = traitList.slice();
        console.log(traits)
        let index = traits.filter((data) => data.traitName == traitName)
        traits.splice(index, 1);



        setTraitList(traits);
        //console.log(traitList,traits)
    }


    /* Method defination for get all collections by user */
    let getAllCollectionsByUser = () => {
        let payload = { "userUuid": getAllSessionData().uuid, "pageNo": "1", "pageSize": "100" }
        setShowLoader(true);
        callAPI('post', NFTAPIBASENAME + '/nft/market/getAllCollectionByUser', payload, true).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftCollections != undefined && response.nftCollections != null) {
                    setNftCollections(response.nftCollections)
                } else {
                    setNftCollections([])
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })

    }

    /* render all collections */
    const renderAllCollections = async () => {
        let contract = await getBlockChainContract();

        if (!contract) return;
        try {
            setShowLoader(true)
            const query = `
            {
              collections {
                id
                name
                description
                backgroundImage
                creator
                volume
                nfts {
                  id
                  tokenURI
                  price
                  owner
                }
              }
            }
          `;

            const response = await axios.post('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', { query });
            const now = Math.floor(Date.now() / 1000);
            const allCollections = response.data.data.collections;
            // Process collections and their NFTs
            const processedCollections = await Promise.all(
                allCollections.map(async (collection) => {
                    // Fetch the floor bid for this collection using the smart contract method
                    const floorBidData = await contract.methods.getFloorBid(collection.id).call();
                    console.log('floorBidData', floorBidData);
                    const isFloorBidExpired = floorBidData.expirationTime > 0 && now > floorBidData.expirationTime;



                    console.log('Combine collection log..', {
                        id: collection.id,
                        name: collection.name,
                        description: collection.description,
                        backgroundImage: collection.backgroundImage,
                        creator: collection.creator,
                        volume: web3.utils.fromWei(collection.volume.toString(), 'ether'),
                        floorBid: {

                            bidder: floorBidData.bidder,
                            bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                            expirationTime: floorBidData.expirationTime,
                            isExpired: isFloorBidExpired,

                        },
                    }
                    );
                    return {
                        id: collection.id,
                        name: collection.name,
                        description: collection.description,
                        backgroundImage: collection.backgroundImage,
                        creator: collection.creator,
                        volume: web3.utils.fromWei(collection.volume.toString(), 'ether'),
                        floorBid: {

                            bidder: floorBidData.bidder,
                            bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                            expirationTime: floorBidData.expirationTime,
                            isExpired: isFloorBidExpired,

                        },
                    };
                })
            );


            console.log('All Collections:', processedCollections);
            let arr = []
            for (let i = 0; i < processedCollections.length; i++) {
                if (processedCollections[i].creator.toLowerCase() == getAllSessionData().account.toLowerCase()) {
                    arr.push(processedCollections[i])
                }
            }
            setNftCollections(arr);
            setShowLoader(false)

        } catch (error) {
            showToast('error', 'Error fetching all collections:' + error);
        }


    }

    const uploadToIPFS = async (file) => {
        const data = new FormData();
        data.append('file', file);

        try {
            const response = await axios.post('https://api.pinata.cloud/pinning/pinFileToIPFS', data, {
                headers: {
                    'pinata_api_key': '6a6acf16ef6baf01fcad',
                    'pinata_secret_api_key': 'c1ffa4ee6d439a780a8a9fc7fd7addefe61605d0d76af84e75ef7ffcac917e71',
                },
            });
            const ipfsHash = response.data.IpfsHash;
            return `ipfs://${ipfsHash}`;
        } catch (error) {
            showToast('error', 'Error uploading file to IPFS:' + error);
            return null;
        }
    };

    /* Method defination for adding NFT */
    let handleAddNft = async () => {
        let contract = await getBlockChainContract();
        let isSessionActive = await isUserSessionActive();
        if (isSessionActive.isActive) {
            if (!contract) return;
            if (getAllSessionData().isLoggedInMetaMask !== 'true') {
                showToast('error', 'Please login with MetaMask');
                return;
            }
            try {
                setShowLoader(true)
                let nftImage = document.getElementById('nftImage').files[0];
                let nftCollection = document.getElementById('nftCollection').value;
                console.log('NFT COLLECTION', nftCollection)
                let nftName = document.getElementById('nftName').value;
                let nftDescription = document.getElementById('nftDescription').value;
                //let nftExternalLink = document.getElementById('nftExternalLink').value;
                const imageIpfsURI = await uploadToIPFS(nftImage);
                if (!imageIpfsURI) {
                    showToast('error', 'Failed to upload image to IPFS');
                    return;
                }
                const metadata = {
                    name: nftName,
                    description: nftDescription,
                    image: imageIpfsURI,
                    collection: nftCollection, // Ensure we're passing the collectionId
                };

                const metadataBlob = new Blob([JSON.stringify(metadata)], { type: 'application/json' });
                const metadataFile = new File([metadataBlob], 'metadata.json');
                const metadataIpfsURI = await uploadToIPFS(metadataFile);

                if (metadataIpfsURI) {
                    try {
                        const estimatedGas = await contract.methods
                            .createNFT(metadataIpfsURI, nftCollection, '0x850a7C982a8A70927F9D497696a0E63eAcDf6b56')
                            .estimateGas({ from: getAllSessionData().account, });
                        await new Promise((resolve, reject) => {
                            console.log('in promise')
                            contract.methods.createNFT(metadataIpfsURI, nftCollection, '0x850a7C982a8A70927F9D497696a0E63eAcDf6b56')
                                .send({ from: getAllSessionData().account, gas: estimatedGas, })
                                .on('transactionHash', (hash) => {
                                    setShowLoader(false)
                                    console.log('Transaction Hash:', hash);
                                })
                                .on('receipt', (receipt) => {
                                    let createdNft = receipt;
                                    console.log(createdNft)
                                    console.log((createdNft['events']['Transfer']['returnValues']['tokenId']))
                                    const createdNftTokenId = (createdNft['events']['Transfer']['returnValues']['tokenId']);
                                    let payload = { "nftTransaction": { "collectionAddress": nftCollection, "tokenId": (createdNftTokenId.toString()).slice(0, -1), "fromUserUuid": getAllSessionData().uuid, "fromUserAddress": getAllSessionData().account, "nftName": nftName, "transactionHash": createdNft['transactionHash'] } }

                                    callAPI('post', NFTAPIBASENAME + '/nft/market/createNft', payload, true).then((res) => {
                                        let response = res.data;
                                        console.log(response);
                                        setShowLoader(false);
                                        if (response.error.error_data != 0) {
                                            showToast('error', response.error.error_msg)
                                        } else {
                                            resolve();
                                            showToast('success', 'NFT created successfully')
                                            props.history.push("/my-nfts");
                                        }

                                    }, (error) => {
                                        setShowLoader(false);
                                        showHttpError(error)
                                    })
                                })
                                .on('error', (error) => {
                                    console.log(error)
                                    setShowLoader(false)
                                    // showToast('error', 'Error Creating collection:' + error);
                                    if (error.code === 4001) {
                                        showToast('error', "Transaction rejected by the user.");
                                    } else {
                                        showToast('error', 'Error Creating collection:' + error);
                                    }
                                    reject(error);
                                }).catch((error) => {
                                    setShowLoader(false)
                                    if (error.code === 4001) {
                                        console.log('User denied transaction signature.');
                                        showToast("error", "Transaction rejected by the user.");
                                    } else {
                                        showToast('error', 'Error in sending transaction:' + error);
                                        showToast("error", `Unexpected error: ${error.message}`);
                                    }
                                    reject(error);
                                });
                        });


                    } catch (error) {
                        setShowLoader(false)
                        console.log('error', error)
                        showToast('error', 'Error creating NFT:' + error);
                    }
                }
            } catch (error) {
                showToast('error', 'Error fetching contract:' + error);
            }
        } else {
            handleLogout()
            setShowLoader(false)
            showToast('error', 'Your session has expired, please login again');
        }




    }

    /* Method defination for minting NFT through METAMASK */
    let mintNftThroughMetaMask = async () => {
        try {
            setShowLoader(true);
            const Web3 = new web3(window.ethereum);
            var myContract = new Web3.eth.Contract(abi, contractAddress, { from: getAllSessionData().account })
            //console.log('PUBLIC KEY',getAllSessionData().account)
            const nonce = await Web3.eth.getTransactionCount(getAllSessionData().account, 'latest'); //get latest nonce the transaction
            //console.log(getAllSessionData().account,nonce)
            //console.log('That IFS LINK',entityData)
            //console.log('Collection contract address',collectionContractAddress)
            const tx = {
                nonce: web3.utils.toHex(nonce),
                from: getAllSessionData().account,
                to: collectionContractAddress,
                data: myContract.methods.safeMint(getAllSessionData().account, entityData).encodeABI(),
                gas: web3.utils.toHex(500000),
                gasPrice: await Web3.eth.getGasPrice()
            };
            //console.log(tx)
            //console.log('PRIVATE KEY',metaMaskPrivateKey)
            const signedTx = await Web3.eth.accounts.signTransaction(tx, metaMaskPrivateKey);
            //console.log(signedTx)
            const transactionReceipt = await Web3.eth.sendSignedTransaction(signedTx.rawTransaction);
            //console.log('Transaction receipt:', transactionReceipt);
            const fee1 = new BigNumber(transactionReceipt.gasUsed).multipliedBy(new BigNumber(transactionReceipt.effectiveGasPrice)).toString()
            //console.log('fee1',fee1)
            //let fee = Web3.utils.fromWei(fee1)
            //console.log('fee',fee)
            let tokenId = Web3.utils.hexToNumber(transactionReceipt?.logs[0]?.topics[3])
            tokenId = tokenId.toString()
            //console.log('tokenId',tokenId)
            // let output = {
            //     statusCode: 1,
            //     message: "NFT Mint successfully",
            //     tokenId: tokenId,
            //     contract: collectionContractAddress,
            //     tokenType: "ERC-721",
            //     gasFee: fee,
            //     ownerUuid: uuid,
            //     txnId: transactionReceipt.transactionHash,
            //     data: transactionReceipt
            // }

            setLastInsertedId(tokenId)
            setShowLoader(false)
            setShowSuccessMintNftModal(true);



        } catch (error) {
            console.log('Error in mintNFT API', error)
            setShowLoader(false);
            showToast('error', 'Error in mintNFT API' + error)
        }
    }

    let openTraitsPopup = () => {
        setShowTraitPopup(true)
    }

    /* Method defination to fetch user balance */
    let getUserBalance = () => {
        // if (getAllSessionData().loginPlatform == 'paybito') {
        //     let payload = { "uuid": getAllSessionData().uuid }
        //     setShowLoader(true)
        //     callAPI('post', NFTAPIBASENAME + '/transaction/getUserBalance', payload, true).then((res) => {
        //         let response = res.data;
        //         setShowLoader(false);
        //         console.log(response);
        //         if (response.error.error_data != 0) {
        //             showToast('error', response.error.error_msg)
        //         } else {
        //             let userBalanceList = response.userBalanceList
        //             if (userBalanceList != null) {
        //                 for (let i = 0; i < userBalanceList.length; i++) {
        //                     if (userBalanceList[i].currencyId == 3) {
        //                         setUserBalance(userBalanceList[i].closingBalance)
        //                     }
        //                 }
        //             }

        //         }

        //     }, (error) => {
        //         setShowLoader(false);
        //         showHttpError(error)
        //     })

        // } else if (getAllSessionData().loginPlatform == 'metamask') {
        let account = getAllSessionData().account;
        window.ethereum
            .request({ method: "eth_getBalance", params: [account, "latest"] })
            .then((balance) => {
                console.log('balance', ethers.utils.formatEther(balance))
                setUserBalance(ethers.utils.formatEther(balance))
            })
            .catch((error) => {
                console.log("Could not detect the Balance");
            });

        //}

    }



    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        /* if (!checkIfUserIsLoggedIn()) {
            showToast('error', 'Please login to continue',);
            setTimeout(() => {
                props.history.push("/");
            }, 1000);
        } else {
            getUserBalance();
            getAllCollectionsByUser();
            
        } */
        getUserBalance();
        renderAllCollections()
    }, []);

    return (
        <Fragment>
            <Header />
            <div className="shop-box-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h3>Create NFT</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <img src={nftImage} alt="Image" style={{ width: '100%', height: '100%' }} />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <div className="form-group">
                                <label>Upload Image*</label>
                                <small> (File size should not be exceeded more than 25MB.)</small>
                                <input type="file" className="form-control" id="nftImage" onChange={(e) => {

                                    let imageFile = e.target.files[0];
                                    if (imageFile.type === 'image/jpeg' || imageFile.type === 'image/jpg' || imageFile.type === 'image/png') {
                                        if (imageFile.size <= 25 * 1024 * 1024) {
                                            setNftImageForPayload(imageFile)
                                            console.log(imageFile)
                                            let reader = new FileReader();
                                            reader.addEventListener("load", (e) => {
                                                setNftImage(e.target.result);

                                            });

                                            reader.readAsDataURL(imageFile);
                                            setBtnMintNft(false)
                                        } else {
                                            setBtnMintNft(true)
                                            showToast("error", "File size should not be exceeded more than 25MB.")
                                        }
                                    } else {
                                        setBtnMintNft(true)
                                        showToast("error", "Please select valid file")
                                    }


                                }} />
                                <small>Upload only jpeg, jpg and png file type.</small>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-9">
                                    <label>Collection*</label>
                                    <select className="form-control" id="nftCollection">
                                        <option value="">Select Collection</option>
                                        {nftCollections.map((collection) => (
                                            <option key={collection.id} value={collection.id.toString()}>{collection.name}</option>
                                        ))}
                                    </select>
                                </div>
                                {/* {getAllSessionData().loginPlatform == 'paybito' ? <div className="col-md-3 pl-0">
                                    <div style={{ marginTop: "34px" }}><Link to="/create-collection" className="btn btn-primary" >Create Collection</Link></div>
                                </div> : <div className="col-md-3 pl-0">
                                    <div style={{ marginTop: "34px" }}><Link to="/import-collection" className="btn btn-primary" >Import Collection</Link></div>
                                </div>} */}
                                <div className="col-md-3 pl-0">
                                    <div style={{ marginTop: "34px" }}><Link to="/import-collection" className="btn btn-primary" >Create Collection</Link></div>
                                </div>

                            </div>
                            <div className="form-group">
                                <label>Name*</label>
                                <input type="text" id="nftName" className="form-control" placeholder='Name your NFT' />
                            </div>
                            <div className="form-group">
                                <label>Description*</label>
                                <textarea className="form-control" id="nftDescription" placeholder='Enter a description'></textarea>
                            </div>
                            {/*  <div className="form-group">
                                <label>External Link</label>
                                <input type="text" className="form-control" id="nftExternalLink" placeholder='https://collection.io/item/123' />
                            </div> */}
                            {/* {getAllSessionData().loginPlatform == 'paybito' && <div className="form-group">
                                <label>Creator Earning (%)*</label>
                                <input type="number" className="form-control" id="nftCreaterEarning" placeholder='Creator Earning' onKeyUp={(e)=>{
                                    let isValid = priceValidation(e.target.value,'creatorearning')
                                    console.log(isValid)
                                    if(!isValid){
                                        showToast("error", "Creater earning should be greater than 0 & less than equals to 100");
                                        e.target.value = ''
                                    }
                                    }} onChange={(e)=>{
                                        let isValid = priceValidation(e.target.value,'creatorearning')
                                        console.log(isValid)
                                        if(!isValid){
                                            showToast("error", "Creater earning should be greater than 0 & less than equals to 100");
                                            e.target.value = ''
                                        }
                                        }}/>
                            </div>} */}
                            {/* {getAllSessionData().loginPlatform == 'paybito' && <div className="form-group">
                                <label>Floor Price*</label>
                                <input type="number" className="form-control" id="floorPrice" placeholder='Floor Price' onKeyUp={(e)=>{
                                    let isValid = priceValidation(e.target.value,'floorprice')
                                    if(!isValid){
                                        showToast("error", "Max 8 digits for floor price");
                                        e.target.value = ''
                                    }
                                    }}/>
                            </div>} */}
                            {/* {getAllSessionData().loginPlatform == 'paybito' && <div className="form-group">
                                <label>NFT Network*</label>
                                <select className="form-control" id="nftNetwork">
                                    <option value="ETHEREUM">ETHEREUM</option>
                                </select>
                            </div>} */}

                        </div>
                    </div>
                    {/*  <div className="row mt-4">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <h2>Traits*</h2>
                                <p>Traits describe attributes of your item. They appear as filters inside your collection page and are also listed out inside your item page.</p>
                                <button className="btn btn-sm btn-info mt-2" onClick={() => { openTraitsPopup() }}> <i className="fa fa-plus mr-2" aria-hidden="true"></i>Add</button>
                            </div>
                            <div className="row">
                                {traitList.map((trait) => (
                                    <div className="col-md-4" key={Math.floor(1000 + Math.random() * 9000)}>
                                        <div className="add-traits">
                                            <div className="row">
                                                <div className="col-md-5">
                                                    {trait.traitName}
                                                </div>
                                                <div className="col-md-4">
                                                    <span>{trait.traitValue}</span>
                                                </div>
                                                <div className="col-md-3">
                                                    <i
                                                        className="fa fa-times-circle"
                                                        aria-hidden="true"
                                                        onClick={() => {
                                                            handleDeleteTraits(trait)
                                                        }}
                                                        style={{ cursor: 'pointer' }}>
                                                    </i>
                                                    <i
                                                        className="fa fa-edit ml-2"
                                                        aria-hidden="true"
                                                        onClick={() => {
                                                            setEditTraitName(trait.traitName);
                                                            setEditTraitValue(trait.traitValue);
                                                            setEditTraitPopup(true);
                                                        }}
                                                        style={{ cursor: 'pointer' }}
                                                    >

                                                    </i>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}


                            </div>
                        </div>
                    </div> */}
                    <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <button className="btn btn-primary" onClick={() => {
                                handleAddNft()
                            }} disabled={btnMintNft}>Save</button>
                        </div>
                    </div>
                </div>
            </div>




            <Fragment>
                <div className={"modal " + (showPrivateKeyMetaMaskPopup ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showPrivateKeyMetaMaskPopup ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Meta Mask Private Key</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setPrivateKeyMetaMaskPopup(false) }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ padding: '4px 7px 4px 11px' }}>
                                    <div className="col-md-12">
                                        <input type="text" className="form-control" onKeyUp={(e) => {
                                            setMetaMaskPrivateKey(e.target.value);
                                        }} />
                                    </div>




                                </div>

                                <center>
                                    <button className="btn btn-primary" onClick={() => { mintNftThroughMetaMask() }}>Proceed</button>
                                </center>


                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            <Fragment>
                <div className={"modal " + (showInsufficientBalancePopup ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showInsufficientBalancePopup ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Add Funds to create NFT</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setInsufficientBalancePopup(false) }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ padding: '4px 7px 4px 11px' }}>
                                    <p>You need <span id="floorPriceDisplay"></span> + {transactionFees}</p>

                                    <p>Transfer funds to your wallet or add funds with {localStorage.getItem('nftBrokerExchangeName')}. It can take up to a minute for your balance to update.</p>
                                    <div className="col-md-12 row">
                                        {/*  <div className="col-md-8">Your {currencyCode} wallet</div> */}
                                        <div className="col-md-12">Balance: {userBalance} {currencyCode}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/* <input */}
                                        </div>
                                    </div>
                                </div>

                                <center>
                                    <a href="https://trade.paybito.com/basic" target="_blank" className="btn btn-primary mt-4 col-md-12">Add Funds</a>
                                </center>


                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            <Fragment>
                <div className={"modal " + (showTraitPopup ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showTraitPopup ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Add Trait</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setShowTraitPopup(false) }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ padding: '4px 7px 4px 11px' }}>
                                    <label>Enter Trait Name*</label>
                                    <input type="text" className="form-control mb-2" id="traitName" placeholder="Enter Trait Name" />
                                    <label>Enter Value*</label>
                                    <input type="text" className="form-control" id="traitValue" placeholder="Enter Trait Value" />
                                    {/*  <label>Enter Floor Price</label>
                                    <input type="text" className="form-control" id="traitFloorPrice" placeholder="Enter Floor Price" value="ETH"/>
                                    <label>Enter Floor Price Network</label>
                                    <input type="text" className="form-control" id="traitFloorPriceNetwork" placeholder="Enter Floor Price Network" /> */}
                                </div>

                                <center>
                                    <button type="button" className="btn btn-primary mt-4 col-md-5" onClick={() => { handleAddTraits() }}>Save</button>
                                </center>


                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>

            <Fragment>
                <div className={"modal " + (showEditTraitPopup ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showEditTraitPopup ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Edit Trait</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setEditTraitPopup(false) }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ padding: '4px 7px 4px 11px' }}>
                                    <label>Edit Trait Name*</label>
                                    <input type="text" className="form-control" value={editTraitName} placeholder="Enter Trait Name"
                                        onChange={(e) => {
                                            if (e.target.value != '') {
                                                setEditTraitName(e.target.value)
                                            }
                                        }} />
                                    <label>Edit Value*</label>
                                    <input type="text" className="form-control" value={editTraitValue} placeholder="Enter Trait Value"
                                        onChange={(e) => {
                                            if (e.target.value != '') {
                                                setEditTraitValue(e.target.value)
                                            }
                                        }}
                                    />

                                    {/*  <label>Enter Floor Price</label>
                                    <input type="text" className="form-control" id="traitFloorPrice" placeholder="Enter Floor Price" value="ETH"/>
                                    <label>Enter Floor Price Network</label>
                                    <input type="text" className="form-control" id="traitFloorPriceNetwork" placeholder="Enter Floor Price Network" /> */}
                                </div>
                                <center>
                                    <button type="button" className="btn btn-primary mt-4 col-md-5" onClick={() => { handleEditTraits() }}>Save</button>
                                </center>

                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>

            <Fragment>
                <div className={"modal " + (showSuccessMintNftModal ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showSuccessMintNftModal ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">

                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <div className='d-flex justify-content-center mt-5 mb-3'>
                                            <img className='justify-content-center' src={nftImage} alt="successNft" style={{ width: "150px", height: "150px", borderRadius: '15px' }} />

                                        </div>
                                    </div>
                                    <div className="col-md-12 col-sm-12">
                                        <h1 className='d-flex justify-content-center mb-2' style={{ fontSize: '30px' }}>Your item has been minted</h1>
                                        <div className="d-flex justify-content-center">
                                            {getAllSessionData().loginPlatform == 'paybito' ? <Fragment><button className='btn btn-secondary mr-2' onClick={() => {
                                                props.history.push("/asset/" + lastInsetedId)
                                            }}>List Item</button>
                                                <button className="btn btn-primary" onClick={() => {
                                                    props.history.push("/asset/" + lastInsetedId)
                                                }}>View Item</button></Fragment> : <Fragment><p>Your minted NFT will be show in collection after sometime. </p>
                                                <button className="btn btn-primary" onClick={() => {
                                                    setShowSuccessMintNftModal(false)
                                                }}>Ok</button>
                                            </Fragment>}

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>






            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default CreateNft;